// src/utils/toaster.js

import { useToast,POSITION } from 'vue-toastification';
// import 'vue-toast-notification/dist/theme-sugar.css';

const toast = useToast();

export const showToast = (type, options = {}) => {
  const templates = {
    addToCart: {
      message: 'Product Added Successfully',
      type: 'info',
      duration: 2000,
    },
    addToCartSuccess: {
      message: 'Product Added Successfully',
      type: 'success',
      duration: 3000,
    },
    removeFromCart: {
      message: 'Product removed from cart!',
      type: 'warning',
      duration: 3000,
    },
    tokenExpired: {
      message: 'Token Expired. Please Login Again',
      type: 'info',
      duration: 3000,
    },
    loginSuccess: {
      message: 'Login Successful',
      type: 'success',
      duration: 3000,
    },
    loginFailed: {
      message: 'Invalid Advisor ID and password',
      type: 'error',
      duration: 3000,
    },
    loginAdminFailed: {
      message: 'Invalid Username or password',
      type: 'error',
      duration: 3000,
    },
    loggedOut: {
      message: 'User Logged Out',
      type: 'success',
      duration: 3000,
    },
    copied: {
      message: 'Link copied to clipboard!',
      type: 'success',
      duration: 3000,
    },
    addedNotification: {
      message: 'Notification Added Successfully',
      type: 'success',
      duration: 3000,
    },
    updatedNotification: {
      message: 'Notification Updated Successfully',
      type: 'success',
      duration: 3000,
    },
    disabledNotification: {
      message: 'Notification Disabled Successfully',
      type: 'success',
      duration: 3000,
    },
    enabledNotification: {
      message: 'Notification Enabled Successfully',
      type: 'success',
      duration: 3000,
    },
    addedBlog: {
      message: 'Blog Added Successfully',
      type: 'success',
      duration: 3000,
    },
    disabledBlog: {
      message: 'Blog Disabled Successfully',
      type: 'success',
      duration: 3000,
    },
    enabledBlog: {
      message: 'Blog Enabled Successfully',
      type: 'success',
      duration: 3000,
    },
    editedBlog: {
      message: 'Blog Edited Successfully',
      type: 'success',
      duration: 3000,
    },
    addedUser: {
      message: 'User Added Successfully',
      type: 'success',
      duration: 3000,
    },
    updatedUser: {
      message: 'User Updated Successfully',
      type: 'success',
      duration: 3000,
    },
    disabledUser: {
      message: 'User Disabled Successfully',
      type: 'success',
      duration: 3000,
    },
    enabledUser: {
      message: 'User Enabled Successfully',
      type: 'success',
      duration: 3000,
    },
    createdUser: {
      message: 'User Created Successfully',
      type: 'success',
      duration: 3000,
    },
    enabledAlbumMedia: {
      message: 'Album Media Enabled Successfully',
      type: 'success',
      duration: 3000,
    },
    disabledAlbumMedia: {
      message: 'Album Media Disabled Successfully',
      type: 'success',
      duration: 3000,
    },
    createdAlbumMedia: {
      message: 'Album Media Created Successfully',
      type: 'success',
      duration: 3000,
    },
    enabledMedia: {
      message: 'Media Enabled Successfully',
      type: 'success',
      duration: 3000,
    },
    disabledMedia: {
      message: 'Media Disabled Successfully',
      type: 'success',
      duration: 3000,
    },
    updatedMedia: {
      message: 'Media Updated Successfully',
      type: 'success',
      duration: 3000,
    },
    createdMedia: {
      message: 'Media Created Successfully',
      type: 'success',
      duration: 3000,
    },
    disabledCategory: {
      message: 'Category Disabled Successfully',
      type: 'success',
      duration: 3000,
    },
    enabledCategory: {
      message: 'Category Disabled Successfully',
      type: 'success',
      duration: 3000,
    },
    addedCategory: {
      message: 'Category Added Successfully',
      type: 'success',
      duration: 3000,
    },
    updatedCategory: {
      message: 'Category Updated Successfully',
      type: 'success',
      duration: 3000,
    },
    technicalError: {
      message: 'Some Technical Error Occurred',
      type: 'error',
      duration: 5000,
    },
    error: {
      message: 'Something went wrong!',
      type: 'error',
      duration: 5000,
    },
    downlineAdded: {
      message: 'Downline Added successfully',
      type: 'info',
      duration: 5000,
    },
    downlineUpdated: {
      message: 'Downline updated successfully',
      type: 'info',
      duration: 5000,
    },
    downlineDeleted: {
      message: 'Downline removed successfully.',
      type: 'info',
      duration: 5000,
    },
    noFrontLineData: {
      message: 'No FrontlineGV data available!',
      type: 'info',
      duration: 5000,
    },
    selectAddress: {
      message: 'Please Select Address First',
      type: 'warning',
      duration: 5000,
    },
    mandatoryColumn: {
      message: 'Mandatory Column',
      type: 'warning',
      duration: 3000,
    },
    stockFinished:{
      message: 'No Stock Left for this Product',
      type: 'warning',
      duration: 3000,
    }
  };

  const toastOptions = templates[type] ? { ...templates[type], ...options } : { ...options };

  toast(toastOptions.message, { type: toastOptions.type, duration: toastOptions.duration,position: POSITION.TOP_CENTER });
};
